import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAdmin } from '../context/adminContext';
import LoginModal from '../components/LoginModel';
import RegisterModal from '../components/RegisterModule';

function Footer() {
  const { admin, logout } = useAdmin();
  const [showRegister, setShowRegister] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  return (
    <footer className="bg-orange-100 text-gray-800 ">
      <div className="max-w-7xl mx-auto px-4 py-8 grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* About Section */}
        <div>
          <h4 className="text-lg font-yatra text-orange-700 mb-2">आमच्याबद्दल</h4>
          <p className="text-sm">
            आम्ही भक्तांसाठी विशेष धार्मिक यात्रा आयोजित करतो. सुरक्षित, सोयीस्कर आणि अध्यात्मिक अनुभव देणे हेच आमचे ध्येय आहे.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-lg font-yatra text-orange-700 mb-2">महत्वाचे दुवे</h4>
          <ul className="text-sm space-y-1">
            <li><a href="/" className="hover:text-orange-600">मुख्यपृष्ठ</a></li>
            <li><a href="/upcoming" className="hover:text-orange-600">आगामी यात्रा</a></li>
            <li><a href="/past-yatra" className="hover:text-orange-600">पूर्ण झालेल्या यात्रा</a></li>
            
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="text-lg font-yatra text-orange-700 mb-2">संपर्क माहिती</h4>
          <p className="text-sm">📞 9552982935</p>
          <p className="text-sm">📧 sirsatashok035@gmail.com</p>
          <p className="text-sm">🏠 किल्ले धारूर, महाराष्ट्र</p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-orange-200 px-4 py-3 flex flex-col md:flex-row items-center justify-between text-sm text-gray-700">
        <p>
      © {new Date().getFullYear()} वारकरी विचार परिवार तीर्थयात्रा. | Developed by{' '}
      <a
        href="https://shivaytech.com"
        target="_blank"
        rel="noopener noreferrer"
        className="text-orange-700 hover:underline"
      >
        ShivayTech
      </a>
    </p>
        <div className="mt-2 md:mt-0 flex gap-3">
         {admin ? (
            <button onClick={logout} className="text-orange-500 font-semibold px-4 py-1 rounded hover:bg-yellow-300">
              लॉगआउट
            </button>
          ) : (
            <>
              {/* <button onClick={() => setShowRegister(true)} className="text-orange-500 font-semibold px-4 py-1 rounded hover:bg-yellow-300">
                रजिस्टर
              </button> */}
              <button onClick={() => setShowLogin(true)} className="text-orange-500 font-semibold px-4 py-1 rounded hover:bg-yellow-300">
                लॉगिन
              </button>
            </>
          )}
        </div>
      </div>
       {showRegister && <RegisterModal onClose={() => setShowRegister(false)} />}
      {showLogin && <LoginModal onClose={() => setShowLogin(false)} />}
    </footer>
  )
}

export default Footer
